import { SubheadingLabel } from '@/styles/fonts'
import { S, getString } from '@grandstand-web/bally-web-shared/src/newPackages/StringMgmt'
import { HeadingLabel } from '@grandstand-web/bally-web-shared/src/styles/fonts'
import Image from 'next/image'
import styled from 'styled-components'

const PromoStoryContainer = styled.div<{ reverse?: boolean }>`
  display: flex;
  width: 100%;
  padding: 48px;
  gap: 93px;
  flex-direction: 'row';
  align-items: center;
  justify-content: center;

  @media (max-width: 1100px) {
    gap: 32px;
    padding: 48px 24px;
  }

  @media (max-width: 820px) {
    flex-direction: ${(props) => (props.reverse ? 'column-reverse' : 'column')};

    justify-content: start;
  }

  @media (max-width: 450px) {
    padding: 48px 16px;
  }
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 45%;
  gap: 24px;
  flex-shrink: 0;

  @media (max-width: 820px) {
    align-self: flex-start;
    max-width: 100%;
  }
`
const ListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 608px;
  gap: 8px;
  text-align: left;
  list-style: outside;
`
const ListItem = styled.li`
  margin-left: 20px;
  align-self: stretch;
`

const ListItemTitle = styled(HeadingLabel)`
  display: flex;
  text-align: left;
`

const ImageContainer = styled.div`
  position: relative;
  max-width: 804px;
  width: 100%;
  max-height: 453px;
  aspect-ratio: 16/9;
  flex-grow: 1;
  @media (max-width: 820px) {
  }

  @media (max-width: 450px) {
    width: 343px;
    height: 192px;
  }
`

const PromoStories = () => {
  return (
    <>
      <PromoStoryContainer reverse>
        <TextContainer>
          <ListItemTitle fontSize="4" mobileFontSize="3">
            {getString('packages.promo1.header')}
          </ListItemTitle>
          <ListContainer>
            <ListItem>
              <SubheadingLabel fontSize="2" mobileFontSize="1">
                {getString('packages.promo1.bullet1')}
              </SubheadingLabel>
            </ListItem>
            <ListItem>
              <SubheadingLabel fontSize="2" mobileFontSize="1">
                {getString('packages.promo1.bullet2')}
              </SubheadingLabel>
            </ListItem>
            <ListItem>
              <SubheadingLabel fontSize="2" mobileFontSize="1">
                {getString('packages.promo1.bullet3')}
              </SubheadingLabel>
            </ListItem>
            <ListItem>
              <SubheadingLabel fontSize="2" mobileFontSize="1">
                {getString('packages.promo1.bullet4')}
              </SubheadingLabel>
            </ListItem>
          </ListContainer>
        </TextContainer>
        <ImageContainer>
          <Image src="/promo-story-image-one.png" alt="Promotinal Image" fill />
        </ImageContainer>
      </PromoStoryContainer>
      <PromoStoryContainer>
        <ImageContainer>
          <Image src="/promo-story-image-two.png" alt="Promotinal Image" fill />
        </ImageContainer>
        <TextContainer>
          <ListItemTitle fontSize="4" mobileFontSize="3">
            {getString('packages.promo2.header')}
          </ListItemTitle>
          <ListContainer>
            <ListItem>
              <SubheadingLabel fontSize="2" mobileFontSize="1">
                <text>
                  <S stringKey="packages.promo2.bullet1" />
                </text>
              </SubheadingLabel>
            </ListItem>
            <ListItem>
              <SubheadingLabel fontSize="2" mobileFontSize="1">
                <text>
                  <S stringKey="packages.promo2.bullet2" />
                </text>
              </SubheadingLabel>
            </ListItem>
            <ListItem>
              <SubheadingLabel fontSize="2" mobileFontSize="1">
                <text>
                  <S stringKey="packages.promo2.bullet3" />
                </text>
              </SubheadingLabel>
            </ListItem>
            <ListItem>
              <SubheadingLabel fontSize="2" mobileFontSize="1">
                <text>
                  <S stringKey="packages.promo2.bullet4" />
                </text>
              </SubheadingLabel>
            </ListItem>
            <ListItem>
              <SubheadingLabel fontSize="2" mobileFontSize="1">
                <text>
                  <S stringKey="packages.promo2.bullet5" />
                </text>
              </SubheadingLabel>
            </ListItem>
          </ListContainer>
        </TextContainer>
      </PromoStoryContainer>
    </>
  )
}

export default PromoStories
